import type { ValueOf } from '#layers/base/public';

/** Height or width in pixels of a fully grown edge fade. */
export const MAX_SCROLL_FADE = 24;

export const ScrollFadeAxis = {
	Vertical: 'vertical',
	Horizontal: 'horizontal',
} as const;

export type ScrollFadeAxis = ValueOf<typeof ScrollFadeAxis>;
